import { Button, Input, Loader, Modal, Typography } from '@finam/web-ui-kit';
import React from 'react';
import { getBase64 } from '../../filesHelper';
import { IUNEPDocument } from '../../Services/ResponseData';
import { WebService } from '../../Services/WebService';
import { TokenContext } from '../../TokenContext';
import { SMSCodePanel } from '../Common/SMSCodePanel';
import FileField from '../Fields/FileField';
import { FileItem } from '../Fields/FileItem';
import './Steps.scss';

interface IState {
    isLoading: boolean;
    isBtnDisabled: boolean;
    showCodePanel: boolean;
    status?: number;
    document?: IUNEPDocument;
    message?: string;
    confirmId?: string;
    phones?: string;
    smscode?: string;
    file?: File
}

interface IProps {
    onError: (short: string, full: string) => void,
    endAction: () => void
}

export default class UNEPStep extends React.Component<IProps, IState>{
    static contextType?= TokenContext;
    context!: React.ContextType<typeof TokenContext>;
    private fileInput: React.RefObject<HTMLInputElement>;

    constructor(props: any) {
        super(props);
        this.fileInput = React.createRef();
        this.state = {
            isLoading: true,
            isBtnDisabled: false,
            showCodePanel: false,
        }
    }

    componentDidMount(): void {
        this.InitStatus();
    }

    private InitStatus() {
        this.setState({ isLoading: true });
        new WebService(this.context.token).GetUNEPStatus().then(res => this.setState({
            isLoading: false,
            document: res.document && { docTypeName: res.document.title, documentID: res.document.id, docTypeNumber: res.document.docType },
            message: res.message,
            status: res.unepStatus
        }));
    }

    private SignDocument() {
        if (this.state.document) {
            this.setState({ isLoading: true });
            const docId = this.state.document.documentID;
            new WebService(this.context.token).SignUNEPDocuments({ docIds: [docId] }).then(res => { this.setState({ isLoading: false, showCodePanel: true, phones: res.phones, confirmId: res.confirmId }) });
        }
    }

    private DownloadDoc(docId: number): void {
        new WebService(this.context.token).DownloadDocument(docId, 0).then(res => {
            var a = document.createElement("a"); //Create <a>
            a.href = res.fileData; //Image Base64 Goes here
            a.download = res.fileName; //File name Here
            a.click(); //Downloaded file
        });;
    }

    private async UploadDoc() {
        if (this.state.file) {
            if (this.state.file.size > 27000000)
                this.props.onError("Размер скана не должен превышать 28мб", "Размер скана не должен превышать 28мб");
            else {
                this.setState({ isLoading: true });
                const data64 = await getBase64(this.state.file);
                await new WebService(this.context.token).PostFileInfo({ items: [{ file64: data64.data, fileName: this.state.file?.name }], nnDoc: this.state.document?.documentID, strDocCode: '' })
            }
        }
    }


    private renderStepByStatus(status?: number): JSX.Element {
        switch (status) {
            case 5:
                return <div className='step-description waitMessage'><p>Для вас уже создана ЭП. Если есть какие-то вопросы обратитесь к своему нанимающему менеджеру. Спасибо.</p></div>
            case 4:
                return <div>
                    <h4 className='step-description__listCaption'>Для создания электронной подписи:</h4>
                    <p className='step-description'>1. Ознакомьтесь с документом по ссылке <a onClick={() => { this.state.document && this.DownloadDoc(this.state.document.documentID) }}>{this.state.document?.docTypeName}</a></p>
                    <p className='step-description'>2. Нажмите на кнопку для подписи документа своей ЭП</p>
                    <Button
                        disabled={this.state.showCodePanel}
                        onClick={() => { this.SignDocument() }}
                    >Подписать</Button>
                    {this.state.showCodePanel && <SMSCodePanel
                        confirmId={this.state.confirmId || ''}
                        docIds={[this.state.document?.documentID || 0]}
                        message={`На ваш телефон ${this.state.phones} ушла СМС с кодом. Пожалуйста введите его в поле ниже и нажмите Отправить`}
                        afterAction={() => { this.setState({ showCodePanel: false }); this.props.endAction(); }}
                    />}

                </div>
            case 2:
                return <div>
                    <h4 className='step-description__listCaption'>Для создания электронной подписи:</h4>
                    <p className='step-description'>1. Скачайте и распечатайте прикрепленный документ <a onClick={() => { this.state.document && this.DownloadDoc(this.state.document.documentID) }}>{this.state.document?.docTypeName}</a></p>
                    <p className='step-description'>2. Подпишите документ собственноручно и прикрепите скан-копию.</p>
                    <FileItem
                        key='uplaodfile_1'
                        title={this.state.document && this.state.document.docTypeName || 'Загрузить'}
                        description={'Успешно загружен'}
                        onClick={() => { this.state.document && this.DownloadDoc(this.state.document.documentID) }}
                        isAddItem={false}
                    />
                    <div><div className='step-description waitMessage'><p>Мы получили ваш подписанный документ, ожидайте ответа в течение двух рабочих дней, вам придет СМС оповещание с результатом.</p></div></div>
                </div>
            case 1:
                return <div>
                    <input ref={this.fileInput}
                        type="file"
                        style={{ display: 'none' }}
                        onChange={(event) => this.setState({ file: event.target.files && event.target.files[0] || undefined })}
                    />
                    <h4 className='step-description__listCaption'>Для создания электронной подписи:</h4>
                    <p className='step-description'>1. Скачайте и распечатайте прикрепленный здесь документ <a onClick={() => { this.state.document && this.DownloadDoc(this.state.document.documentID) }}>{this.state.document?.docTypeName}</a></p>
                    <p className='step-description'>2. Подпишите документ собственноручно и прикрепите скан-копию.</p>
                    <FileItem
                        key='uplaodfile_1'
                        title={this.state.file && this.state.file.name || 'Загрузить'}
                        description={this.state.file && 'Новый' || 'Не более 15 Мб'}
                        onClick={() => { if (!this.state.file) this.fileInput.current?.click(); }}
                        isAddItem={!this.state.file}
                    />
                    <Button
                        disabled={!this.state.file}
                        onClick={() => { this.UploadDoc().then(res => this.InitStatus()) }}
                    >Получить УНЭП</Button>
                </div>
            case 0:
                return <Button
                    disabled={this.state.isBtnDisabled}
                    onClick={() => { this.setState({ isLoading: true }); new WebService(this.context.token).GetNewUNEP().then(res => this.InitStatus()) }}
                >Получить УНЭП</Button>
            default:
                return <p>{this.state.message}</p>
        }
    }

    render() {
        return <div className='unep'>
            <h2 className='step-title'>Создайте электронную подпись</h2>
            <p className='step-description'>
                Усиленная неквалифицированная электронная подпись (УНЭП) – это криптографический ключ, с помощью которого можно осуществлять подписание электронных документов без физического присутствия.
            </p>
            <p className='step-description'>При этом в отличие от квалифицированной подписи к НЭП предъявляются менее строгие правила. Система криптошифрования, используемая для ее создания, может быть любой.
                <b>Для получения УНЭП нажмите на кнопку ниже.</b></p>
            <p className='step-description morovileLink'><a target="_blank" rel="noopener noreferrer" href='http://www.moreville.ru/documents/main/default.asp'>Регламент ООО «Моревиль»</a></p>
            <div className='step-actionSection'>
                {this.state.isLoading ? <Loader /> : this.renderStepByStatus(this.state.status)}
            </div>
        </div>;
    }
} 